module.exports = __webpack_public_path__ + "img/img4.cb69a58b.png";